import { ref } from "vue"
import axios from "axios"

const path = "/partner/customers/can_get_trial_by_partner"

const useEmailValidation = (email, reseller) => {
  const error = ref(false)
  const errorMessage = ref("")
  const isLoading = ref(false)
  const requires = ref("")
  const userId = ref("")

  const validateEmail = async () => {
    error.value = false
    errorMessage.value = ""

    if (!email.value || email.value.length === 0) {
      errorMessage.value = "Email address required."
      error.value = true
      return
    }

    if (/(^.+@.+\..+$)/.test(email.value)) {
      try {
        isLoading.value = true
        const { data } = await axios.post(path, { customer_email: email.value, involved_reseller: reseller.value?.email })
        requires.value = data.requires
        userId.value = data.userId
      }
      catch ({ response, message }) {
        errorMessage.value = response?.data?.message || message
        error.value = true
      }
      finally {
        isLoading.value = false
      }
    }
    else {
      errorMessage.value = "Email must be in the correct format."
      error.value = true
    }
  }

  return {
    validateEmail,
    error,
    errorMessage,
    isLoading,
    requires,
    userId,
  }
}

export {
  useEmailValidation,
}
